<ng-container *t="let t">
    <div class="content-section" *ngIf="isPrimaryValidation === true || isSecondaryContact === true">
        <!-- ValidationTask check-->
        <tsl-alert status="info" *ngIf="!validationTask; else showmsg" i18n="@@812505104212945478"
            transloco="812505104212945478">
            You do not have access to view this data or change functionality due to your organization’s Primary Contact
            missing a Primary Contact Form. Your assigned Primary Contact can submit the Primary Contact Form by
            navigating
            to the Guidelines page, downloading a copy of the form, and uploading a completed document by editing their
            own
            contact information below. This submission will go to Tesla for review for validation purposes.
        </tsl-alert>
        <ng-template #showmsg>
            <ng-container [ngSwitch]="validationTask.statusId">
                <tsl-alert status="info" *ngSwitchCase="1">
                    <p i18n="@@6867665126144963083" transloco="6867665126144963083">As your contacts have not yet been
                        validated you do not have complete user access and, if
                        applicable, change functionality within the Supplier Portal. Please reach out to the Tesla
                        Vendor
                        Changes Team for further assistance
                    </p>
                    <div>
                        <span i18n="@@9097415673098704514" t="9097415673098704514" style="font-weight: bold;">
                            Tesla Supplier onboarding and data inquiries
                        </span>
                        <br />
                        <span i18n="@@contactVendorChanges" t="contactVendorChanges">
                            Contact the Vendor Changes Team at the following resources:
                        </span>
                        <br />
                        <ul>
                            <li>
                                <span i18n="@@globalTeamRegions" t="globalTeamRegions">
                                    EMEA/NA/SA:
                                </span>
                                <a class="link" i18n="@@HomeTabHelpNewEmail" t="HomeTabHelpNewEmail" href="mailto:Vendorchanges@tesla.com">
                                    Tesla Vendor Changes Team
                                </a>
                            </li>
                            <li>
                                <span i18n="@@apacTeamRegions" t="apacTeamRegions">
                                    APAC/CN:
                                </span>
                                <a class="link" i18n="@@VendorchangesapacEmail" t="VendorchangesapacEmail" href="mailto:Vendorchangesapac@tesla.com">
                                    Tesla Vendor Changes APAC Team
                                </a>
                            </li>
                        </ul>
                    </div>
                </tsl-alert>
                <ng-container *ngSwitchCase="3">
                    <tsl-alert class="alert" status="info" *ngIf="!isPCFUploaded">
                        <span i18n="@@notAuthenticated"
                            t="notAuthenticated" style="font-weight: bold;">
                            Your account is not fully authenticated.
                        </span>
                        <br>
                        <span i18n="@@noeditFunctionality"
                            t="noeditFunctionality">
                            No edit functionality available at this time.
                        </span>
                        <br>
                        <span i18n="@@enrollToMFA"
                            t="enrollToMFA">
                            (Re)authentication or (Re)enrollment in Multi-Factor Authentication required.
                        </span>
                        <br />
                        <a style="text-decoration: underline; font-weight: bold; cursor: pointer;"
                            [ngClass]="{ 'disable_link': primaryPendingForApproval == true }"
                            [disabled]="preventativeHold==true" (click)="openPCFDialog()">Take Action</a>
                    </tsl-alert>
                </ng-container>
                <ng-container *ngSwitchCase="2">
                    <tsl-alert status="info">
                        <p>
                            <span i18n="@@4552874665027862249" transloco="4552874665027862249">
                                As the Contact Validation Task by your organization's Primary Contact</span>
                            <span class="bold-info"> {{ validationTask.email }} </span>
                            <span i18n="@@6667155305668146063" transloco="6667155305668146063">is currently pending, you
                                currently do not have access to view this data or change
                                functionality. In order to view this data, please notify the above contact and request
                                they
                                log into the Tesla Supplier Portal and complete the task by </span><span
                                class="bold-info"> {{
                                validationTask.dueDateValue }} </span>.
                        </p>
                        <p *ngIf="isPrimary">
                            <span i18n="@@3295845337056041526" transloco="3295845337056041526">To access this task,
                                please click</span>
                            <a class="bold-info" href="#" (click)="navigateToValidationTask()">HERE</a>.
                        </p>
                        <p>
                            <span><b i18n="@@e16702600f3bb303dcf8e62cf280925c67db2f88"
                                    transloco="e16702600f3bb303dcf8e62cf280925c67db2f88">Please
                                    Note</b></span>
                            <span i18n="@@5366570134397127155" transloco="5366570134397127155">
                                : Your portal account will be deactivated along other contacts within your organization,
                                consisting of all their portal access rights if NOT validated by the due date. This
                                includes
                                access to Shipping 2.0, Quality, FTA Compliance, Carrier, E-Invoicing, Invoice Reports,
                                and
                                Supplier Profile.</span>
                        </p>
                    </tsl-alert>
                </ng-container>
                <ng-container *ngSwitchCase="5">
                    <tsl-alert status="info" i18n="@@5707243002146290694" transloco="5707243002146290694">
                        The Contact Validation Task is currently pending review with Tesla which may take up to 24 to 48
                        hours from the time of submission of the most recently completed task. Change functionality will
                        be
                        instated and applicable user access granted once all tasks have been completed and approved.
                    </tsl-alert>
                </ng-container>
                <tsl-alert status="info" *ngSwitchDefault i18n="@@4804233320533880161" transloco="4804233320533880161"
                    [translocoParams]="{ INTERPOLATION: validationTask.email }">
                    As the Contact Validation Task by your organization’s Primary Contact
                    {{ validationTask.email }} is still pending, you currently do not have access to view this data or
                    change functionality. In order to view this data, please notify the above contact and request they
                    log
                    into the Tesla Supplier Portal and complete the task, which can be located on the Validation Task
                    tab on
                    Contacts page.</tsl-alert>
            </ng-container>
        </ng-template>
        <div class="row">
            <div class="col-8" *ngIf="
                    (this.isPrimary || this.isProfileAdmin) && missingCriticalContacts && missingCriticalContacts.length > 0
                ">
                <div style="color: #c00" i18n="@@edaeff1868d14a05cafccae58d55bd2b7b00143a"
                    transloco="edaeff1868d14a05cafccae58d55bd2b7b00143a">
                    Your Supplier Profile is missing critical contacts. Please add/assign these contacts for the
                    completion
                    of your supplier profile.
                </div>
                <ul class="list" *ngFor="let item of missingCriticalContacts">
                    <li class="list-item">
                        <label class="status status-alt status-error">{{ item }}</label>
                    </li>
                </ul>
            </div>
            <div class="col right top-buttons">
                <!-- todo ttp -->
                <button tsl-button size="small" color="black" outline tooltip="Show History"
                    i18n-tooltip="@@2279638681844186468" #historyButton
                    tslTooltip="{{ t('2279638681844186468', historyButton) }}"
                    *ngIf="this.userDetails && tabPermissions?.contact != 'NoAccess'" (click)="showHistory()"
                    i18n="@@efac3af0b32e953279c25b6519cae256811e0fe8"
                    transloco="efac3af0b32e953279c25b6519cae256811e0fe8">History</button>
                <button type="button" [ngStyle]="{ 'margin-right.px': 10 }" tsl-button size="small" color="blue" filled
                    class="nav-item nav-link-edit" *ngIf="hasWriteAccess" [disabled]="preventativeHold==true"
                    (click)="openDialog(null)" i18n="@@a99c09975ed76d8da13b0f8e552389c9ab8f2e43"
                    transloco="a99c09975ed76d8da13b0f8e552389c9ab8f2e43">Add Contact</button>
            </div>
        </div>
        <div>
            <table tsl-table [dataSource]="gridViewData">
                <ng-container tslColumnDef="purpose">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@4700d8eb82eeede253c4e7f323fe37906e6e85a3"
                        transloco="4700d8eb82eeede253c4e7f323fe37906e6e85a3">
                        Purpose
                    </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div *ngIf="element?.types?.newValue; else empty">
                            {{ element?.types?.newValue?.join(', ') }}
                        </div>
                        <!-- <ng-container *ngFor="let type of element?.types?.newValue | sortBy:'asc'">
                            <div [ngSwitch]="type">
                                <tsl-chip *ngSwitchCase="'Primary'" size="medium" class="contact_role success">{{type}}</tsl-chip>
                                <tsl-chip *ngSwitchCase="'Finance Lead'" size="medium" class="contact_role warning">{{type}}</tsl-chip>
                                <tsl-chip *ngSwitchCase="'Remit To'" size="medium" class="contact_role error">{{type}}</tsl-chip>
                                <span *ngSwitchDefault>{{type}}</span>
                            </div>
                        </ng-container> -->
                    </td>
                </ng-container>
                <ng-container tslColumnDef="name">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@09167ed20c5b053ae27c53a5d4ee11989aabfe2f"
                        transloco="09167ed20c5b053ae27c53a5d4ee11989aabfe2f">
                        Full Name
                    </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div *ngIf="getFullName(element, 'newValue'); else empty">
                            {{ getFullName(element, 'newValue') }}</div>
                    </td>
                </ng-container>
                <ng-container tslColumnDef="mobile">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@7ef67f76ab81c082a91782412af3639cca2126de"
                        transloco="7ef67f76ab81c082a91782412af3639cca2126de">Mobile
                    </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div *ngIf="element.mobile.newValue; else empty">
                            <app-display-cell [propertyValue]="element.mobile"></app-display-cell>
                        </div>
                        <!-- <ng-template #empty>
                  <tsl-icon>maximize</tsl-icon>
                </ng-template> -->
                </ng-container>
                <ng-container tslColumnDef="phone">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@6934d8edd276d59e050006fe91b695ebad0218f8"
                        transloco="6934d8edd276d59e050006fe91b695ebad0218f8">Phone
                    </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div *ngIf="element.phone.newValue; else empty">
                            <app-display-cell [propertyValue]="element.phone"></app-display-cell>
                        </div>
                    </td>
                </ng-container>
                <ng-container tslColumnDef="jobTitle">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@20d9489fdbfc121f7c504271b36691515d02f632"
                        transloco="20d9489fdbfc121f7c504271b36691515d02f632">Job Title
                    </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div *ngIf="element.jobTitle.newValue; else empty">
                            <app-display-cell [propertyValue]="element.jobTitle"></app-display-cell>
                        </div>
                    </td>
                </ng-container>
                <ng-container tslColumnDef="languageCode">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@917fe77920bc5c5f63200a05b50ac35b1d0e9156"
                        transloco="917fe77920bc5c5f63200a05b50ac35b1d0e9156">Email communication language
                    </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div *ngIf="getLanguage(element?.languageCode?.newValue); else empty">
                            {{ getLanguage(element?.languageCode?.newValue) }}
                        </div>
                    </td>
                </ng-container>
                <ng-container tslColumnDef="email">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@244aae9346da82b0922506c2d2581373a15641cc"
                        transloco="244aae9346da82b0922506c2d2581373a15641cc">Email
                    </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div *ngIf="element.email.newValue; else empty">
                            <app-display-cell [propertyValue]="element.email"></app-display-cell>
                            <div align="end">
                                <i *ngIf="
                                        element.types?.newValue?.indexOf('Portal Account') > -1 ||
                                        element.types?.newValue?.indexOf('Initial Onboarding') > -1 ||
                                        element.types?.newValue?.indexOf('Extended Onboarding') > -1
                                    " i18n="@@320c1ab8ad0f7c2b4086b43a8dbbf8645b6e7d1d"
                                    transloco="320c1ab8ad0f7c2b4086b43a8dbbf8645b6e7d1d">(Active in portal)</i>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <ng-container tslColumnDef="financeLead">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@5691b480d7e4c90672c91e4ca54f9f96ad0515f9"
                        transloco="5691b480d7e4c90672c91e4ca54f9f96ad0515f9">
                        Finance Lead
                    </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div>
                            <!-- todo ttp -->
                            <i *ngIf="element?.types?.newValue?.indexOf('Finance Lead') > -1; else empty"
                                class="material-icons tg-icon" i18n-matTooltip matTooltip="Yes"
                                matTooltipPosition="right">check</i>
                        </div>
                    </td>
                </ng-container>
                <ng-container tslColumnDef="remitTo">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@f566f801c1ed95033beaf61c2dfc3256cbf56f34"
                        transloco="f566f801c1ed95033beaf61c2dfc3256cbf56f34">Remit To
                    </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div>
                            <!-- todo ttp -->
                            <i *ngIf="element?.types?.newValue?.indexOf('Remit To') > -1; else empty"
                                class="material-icons tg-icon" i18n-matTooltip matTooltip="Yes"
                                matTooltipPosition="right">check</i>
                        </div>
                    </td>
                </ng-container>
                <ng-container tslColumnDef="isPrimaryAccount">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@0fcc4dbb334c364f178d8b1daaece38d13a4fbe3"
                        transloco="0fcc4dbb334c364f178d8b1daaece38d13a4fbe3">Primary Contact
                    </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div>
                            <!-- todo ttp -->
                            <i *ngIf="element?.types?.newValue?.indexOf('Primary') > -1; else empty"
                                class="material-icons tg-icon" i18n-matTooltip matTooltip="Yes"
                                matTooltipPosition="right">check</i>
                        </div>
                    </td>
                </ng-container>
                <ng-container tslColumnDef="supplierCodes">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@7a143ea08fbc43e84ebd706e5bbfe2a4b218e179"
                        transloco="7a143ea08fbc43e84ebd706e5bbfe2a4b218e179">
                        Linked Supplier Codes
                    </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div *ngIf="element?.supplierCodes?.newValue; else empty">
                            {{ element?.supplierCodes?.newValue?.join(', ') }}
                        </div>
                    </td>
                </ng-container>
                <ng-container tslColumnDef="action">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@01a32bb7e93373cbc305329319efc67c0bd85226"
                        transloco="01a32bb7e93373cbc305329319efc67c0bd85226">
                        Action
                    </th>
                    <td tsl-cell *tslCellDef="let element" class="actions icons" width="8%">
                        <div *ngIf="hasEditPermissions">
                            <div *ngIf="element.operation.newValue">
                                <div class="task-status">
                                    <tsl-chip [ngClass]="statusClass['Under Tesla Review']">
                                        {{ translate.get(statusDisplay['Under Tesla Review']) }}
                                    </tsl-chip>
                                </div>
                            </div>
                            <button tsl-icon-button *ngIf="!element.operation.newValue" (click)="openDialog(element)"
                                [disabled]="
                                    !(
                                        element.canUpdateItem &&
                                        !hasDraftValidationTask &&
                                        !hasPendingValidationTask &&
                                        element.operation?.newValue !== 'Delete' &&
                                        (isPCFUploaded || element.types?.newValue?.indexOf('Primary') >= 0)
                                    ) || preventativeHold==true
                                ">
                                <tsl-icon status="primary"
                                    tslTooltip="{{ translate.get(isContactValidationPendingTaskErrorMessage) }}"
                                    [tslTooltipDisabled]="
                                        element.canUpdateItem &&
                                        !hasDraftValidationTask &&
                                        !hasPendingValidationTask &&
                                        element.operation?.newValue !== 'Delete' &&
                                        (isPCFUploaded || element.types?.newValue?.indexOf('Primary') >= 0)
                                    ">edit</tsl-icon>
                            </button>
                            <button tsl-icon-button *ngIf="!element.operation.newValue" (click)="deleteItem(element)"
                                [disabled]="
                                    !(
                                        element.canDeleteItem &&
                                        !hasDraftValidationTask &&
                                        !hasPendingValidationTask &&
                                        element.operation?.newValue !== 'Delete' &&
                                        isPCFUploaded
                                    )|| preventativeHold==true
                                ">
                                <tsl-icon status="error"
                                    tslTooltip="{{ translate.get(isContactValidationPendingTaskErrorMessage) }}"
                                    [tslTooltipDisabled]="
                                        element.canUpdateItem &&
                                        !hasDraftValidationTask &&
                                        !hasPendingValidationTask &&
                                        element.operation?.newValue !== 'Delete' &&
                                        (isPCFUploaded || element.types?.newValue?.indexOf('Primary') >= 0)
                                    ">delete</tsl-icon>
                            </button>
                        </div>
                    </td>
                </ng-container>

                <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
                <tr tsl-row *tslRowDef="let row; columns: displayedColumns"></tr>

                <ng-template #empty>
                    <tsl-icon>maximize</tsl-icon>
                </ng-template>
            </table>

            <div>
                <tsl-pagination [pageSizeOptions]="pageSizeOptions" showFirstLastButtons
                    (pageChange)="pageChange($event)" [total]="totalRows" [pageSize]="currentPageSize"
                    [itemsPerPageLabel]="translate.get('ItemsPerPage')"></tsl-pagination>
            </div>
        </div>
    </div>
    <div *ngIf="isPrimaryValidation !== true && isSecondaryContact !== true"
        i18n="@@1354e80cca1deb451dd18930b12b52528fbc99f1" transloco="1354e80cca1deb451dd18930b12b52528fbc99f1">
        You don't have permission to see this section.
    </div>
</ng-container>